/*
 * Ryan O'Dowd
 * 2023-01-21
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({isDarkMode, globalScale, fonts, colors}) => {
  return {
    container: {
      flexDirection: 'row',
      width: '100%',
    },
    myMessageContainer: {
      justifyContent: 'flex-end',
    },
    containerInner: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      maxWidth: '60%',
      padding: 8,
      borderRadius: 8,
      margin: 4,
      fontSize: 14,
      backgroundColor: colors.otherNote,
      color: colors.black,
    },
    botMessageContainer: {
      justifyContent: 'center',
    },
    myMessageContainerInner: {
      backgroundColor: colors.myNote,
      alignItems: 'flex-end',
    },
    noteBody: {
      display: 'flex',
      flexDirection: 'column',
    },
    line: {
      marginBottom: 8,
      color: colors.primaryExtraDark,
    },
    botMessageContainerInner: {
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    botMessageText: {
      fontFamily: fonts.primaryItalic,
      textAlign: 'center',
      color: isDarkMode ? colors.lightGray : colors.gray,
    },
    rightWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    user: {
      color: colors.gray,
      fontSize: globalScale * 10,
      fontFamily: fonts.primaryItalic,
      textAlign: 'right',
    },
    myMessageUsername: {
      justifyContent: 'flex-end',
    },
  };
};

export default getStyles;
